import { Card } from 'antd';
import { observer } from 'mobx-react-lite';

import { PageContent } from 'app/ui';

export const NotFoundPage = observer(() => (
  <PageContent>
    <Card size="small">Упс, неверный адрес страницы 🤔</Card>
  </PageContent>
));
